import { DEFAULT_PAGE_NUMBER } from 'utils/constants';
import mergeById from 'utils/mergeById';
import { FormSearchQuery } from 'generated/graphql';

type FormSearch = FormSearchQuery['formSearch'];

const stitchSearchPages = (previous: FormSearch | undefined, next: FormSearch): FormSearch => {
  if (!previous || next.page.page === DEFAULT_PAGE_NUMBER) return next;
  return { ...next, results: mergeById(previous.results, next.results, (option) => option.entityID) };
};

export default stitchSearchPages;
